/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Perm_Business_MetricsInputs */

const vi_api_keys_perm_business_metrics = /** @type {(inputs: Api_Keys_Perm_Business_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ số kinh doanh`)
};

/**

* @param {Api_Keys_Perm_Business_MetricsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_perm_business_metrics = /** @type {((inputs?: Api_Keys_Perm_Business_MetricsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Perm_Business_MetricsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_perm_business_metrics(inputs)
});